export const METHOD_TESTING_WITH_OPTIONS = 'testing-with/';
export const METHOD_EXPECTED_DELIVERABLE_OPTIONS = 'expected-deliverable/'
export const METHOD_CO_CREATION = 'cocreation/';
export const METHOD_CO_CREATION_FILE_UPLOAD = 'co-creation-resource/';
